import moment from 'moment';
import store from '@/store';

// 1 - Caso o formato seja informado, retorna uma string da data conforme o formato
// Formatos Aceitos: https://momentjs.com/docs/#/parsing/string-format/
// 2 - Caso o formato não seja informado, retorna um objeto de data do moment
// https://momentjs.com/docs/#/query/
function get(formato) {
  if (formato) {
    return moment(store.state.app.dataAtual).format(formato);
  }
  return moment(store.state.app.dataAtual);
}

// Retorna um objeto de data do moment
function create(data) {
  return moment(data);
}

// Retorna uma string de data conforme um formato
// Caso não seja passado o formato, o default é 'DD/MM/YYYY'
function format(data, formato = 'DD/MM/YYYY') {
  return moment(data).format(formato);
}

// Compara datas com moment
// [a] [b] datas a serem comparadas
// [precisao] parametro para refinar a comparação das datas ('days', 'month', 'year')
function compare(metodo, opcoes = { a: null, b: null, precisao: null }) {
  if (metodo) {
    if (!opcoes.a) {
      opcoes.a = store.state.app.dataAtual;
    }
    if (!opcoes.b) {
      return moment(opcoes.a)[metodo]();
    }
    return moment(opcoes.a)[metodo](moment(opcoes.b), opcoes.precisao ? opcoes.precisao : 'days');
  }
  return null;
}

// Retorna a menor data
function min(datas) {
  return moment.min(datas.map((d) => moment(d)));
}

// Retorna a maior data
function max(datas) {
  return moment.max(datas.map((d) => moment(d)));
}

export default {
  get, create, format, compare, min, max,
};
